module.exports = __webpack_public_path__ + "static/media/2.15007fb5.webp";